import React from 'react'
import clsx from 'clsx'
import { PaginationState, Table } from '@tanstack/react-table'

import PageSize from './PageSize'
import NavButtons from './NavButtons'

import useStyles from './styles'

type PaginationProps<T> = {
  table: Table<T>
  paginationOptions: number[]
  isSmall?: boolean
  hidePaginationPage?: boolean
  manualPagination?: boolean
  numResults?: number
  pageNum?: number
  pagination: PaginationState
  setPagination: React.Dispatch<React.SetStateAction<PaginationState>>
}

const Pagination = <T extends unknown>({
  table,
  paginationOptions,
  isSmall,
  hidePaginationPage,
  manualPagination,
  numResults,
  pageNum,
  pagination: { pageIndex, pageSize },
  setPagination
}: PaginationProps<T>) => {
  const numRows = React.useMemo(() => table.getRowModel().rows.length, [table])

  const classes = useStyles()

  return (
    <div className={clsx(classes.root, isSmall && classes.smallRoot)}>
      {!isSmall &&
        (hidePaginationPage ? (
          <div />
        ) : (
          <div className='num'>
            <PageSize
              rowsPerPage={pageSize}
              onChangeRowsPerPage={pageSize =>
                setPagination(old => ({ ...old, pageSize }))
              }
              paginationOptions={paginationOptions}
            />
          </div>
        ))}

      <div className='buttons'>
        <NavButtons
          count={manualPagination ? numResults ?? numRows : numRows}
          page={manualPagination ? pageNum ?? pageIndex : pageIndex}
          rowsPerPage={pageSize}
          onChangePage={table.setPageIndex}
          isSmall={isSmall}
        />
      </div>

      <div />
    </div>
  )
}

export default Pagination
